export const hardcodedValues = {
  'Accounts Receivable-Concentration over 20%': 1562101,
  'Accounts Receivable-Over 90 days old': 740820,
  'Accounts Receivable-Foreign accounts': 10210,
  'Accounts Receivable-Misc. Ineligibles': 60394,
  'Inventory Summary-Depreciation': 175030,
  'Inventory Summary-Slow-moving Inventory (no sale in 12 months)': 89000,
  'Inventory Summary-Promotional Items': 20000,
  'Inventory-Depreciation': 175030,
  'Inventory-Slow-moving Inventory (no sale in 12 months)': 89000,
  'Inventory-Promotional Items': 20000,
  'Equipment-Depreciation': 97000,
  'Equipment-Misc. Ineligible Equipment': 407827,
  'Accounts Receivable': 7175134.09,
  'Inventory Summary': 2780100,
  Inventory: 2780100,
  Equipment: 2275093,
}
